import axios from "axios";
import { HTTP_REQUEST_POST } from "../Utils/appConstants";
export default function service(
  token,
  path,
  input,
  responseCallBack,
  errorCallBack
) {

  const url =
  process.env.REACT_APP_API_URL +
  "/" +
  process.env.REACT_APP_SERVICE_PATH +
  "/" +
  path;

console.log("FINAL URL =", url);

  axios({
    method: HTTP_REQUEST_POST,
    url: url,
    data: input,
    headers: {
      "Access-Control-Allow-Origin": "*",
      securitykey: token,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      responseCallBack(response);
    })
    .catch((error) => {
      console.log("error data :: ", error);
      errorCallBack(error);
    });
}
